module.exports = __webpack_public_path__ + "img/8c50d79.jpg";